/** @module SiteAdmin/SelectSet/NewSelectSetItem */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def/ViewRef",
	"csi/reflection",
	"csi",
	"csi/xml",
	"csi/xml/Query",
	"./SelectSetHelper",
	"Apparel/NewFilteredItem",
	"SiteAdmin"
], function(declare, lang, config, ViewRef, reflection, csi, xml, Query, SelectSetHelper, NewFilteredItem, SiteAdmin) {

	return declare(NewFilteredItem, {
		/**
		 * Set the ViewRef according to the type.
		 */
		constructor: function(/*Object*/params) {
			var type = SelectSetHelper.getSubtypeName(this.getParent());
			var url = type == "PurchasedOrder" ? "centric://REFLECTION/INSTANCE/LibSourcing/SiteLibrary" : "centric://APPAREL/Views";
			lang.mixin(this.m_action, {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_url: url,
					m_id: SelectSetHelper.SELECT_SET_TYPE_VIEW_REF_DEF[type]
				})
			});
		},

		/**
		 *@override
		 *Allow to be selected multiple times if allowDuplicates is true
		 */
		getFormData: function() {
			const fd = this.inherited(arguments);

			// see if our SelectSet allows duplicates and if so, reset the aggregations so you can select items again
			const allowDuplicates = config.getNodeSetting(this.getParent(), "AllowDuplicates");
			if (allowDuplicates) {
				fd.resetAggregations();
			}

			return fd;
		},

		/**
		 * @override
		 * Update properties view when new items selected
		 */
		postProcessSuccess() {
			SiteAdmin.postActionSelectSetItem(this);
			return this.inherited(arguments);
		},

		/**
		 * Get initial query with filter for active flag.
		 * @return {Query} The query with filter for active flag.
		 */
		_getQueryFilterInitialQuery: function() {
			var createdAt = this.getParent().__Parent__;
			var q = new Query();
			if (createdAt && createdAt != csi.EMPTY_URL) {
				createdAtNode = this.getContext().cache.getNode(createdAt, true);
				if (createdAtNode) {
					createdAtType = createdAtNode.$Type;
					var selectSet = this.getParent();
					switch (selectSet.Subtype) {
						case "centric://REFLECTION/INSTANCE/SelectSetSubtype/ApparelBOM":
							var path = reflection.PATH_PARENT;
							q = q.RefAttr(createdAtType == "Season" ? "ParentSeason" : createdAtType, xml.OP_EQUALS, createdAt, path);
							break;
						case "centric://REFLECTION/INSTANCE/SelectSetSubtype/Style":
							q = q.RefAttr(createdAtType == "Season" ? "ParentSeason" : createdAtType, xml.OP_EQUALS, createdAt);
							break;
						case "centric://REFLECTION/INSTANCE/SelectSetSubtype/StyleSupplierItem":
							var path = reflection.PATH_PARENT + "/" + reflection.PATH_PARENT + "/" + reflection.PATH_PARENT;
							q = q.RefAttr(createdAtType == "Season" ? "ParentSeason" : createdAtType, xml.OP_EQUALS, createdAt, path);
							break;
					}
				}
			}
			return q;
		}
	});
});